// extracted by mini-css-extract-plugin
export default {"wrapper":"allocation-chart_wrapper__Mw7FM","chartHeader":"allocation-chart_chartHeader__dWIb0","graphWrapper":"allocation-chart_graphWrapper__N0aBb"};